import { KaufpreisProductFormModel } from '../factories/kaufpreis-product-form.factory';

export function checkForProductDataInUrl(url: URL, productForm: KaufpreisProductFormModel): KaufpreisProductFormModel {
  if (!productForm.brand.value && url.searchParams.has('hersteller')) {
    productForm.brand.setValue(url.searchParams.get('hersteller'));
  }

  if (!productForm.model.value && url.searchParams.has('modell')) {
    productForm.model.setValue(url.searchParams.get('modell'));
  }

  if (!productForm.dateOfFirstRegistration.value && url.searchParams.has('erstzulassung')) {
    productForm.dateOfFirstRegistration.setValue(url.searchParams.get('erstzulassung'));
  }

  if (!productForm.mileage.value && url.searchParams.has('kilometerstand')) {
    productForm.mileage.setValue(Number(url.searchParams.get('kilometerstand')));
  }

  return productForm;
}
